"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { HeartHandshake } from "lucide-react";
const teamMembers = [{
  name: "\n",
  role: "物理治療師",
  bio: "資深物理治療師，擁有逾10年臨床復康經驗。專長於中風康復與痛症管理，致力為長者制定個人化復康計劃。",
  img: "https://wanted-kite.10web.cloud/wp-content/uploads/2026/03/物理治療師_深紫色-scaled.png?v=y6gf9jzqfmj"
}, {
  name: "\n",
  role: "職業治療師",
  bio: "專業職業治療師，深耕認知障礙症護理與家居改裝建議。透過日常生活功能訓練，協助服務使用者重拾自理能力。",
  img: "https://wanted-kite.10web.cloud/wp-content/uploads/2026/03/7-scaled.png?v=ehs4tyayz1a"
}, {
  name: "\n",
  role: "言語治療師",
  bio: "專注於吞嚥困難評估與語言康復訓練。持有多項國際認證，為溝通障礙者提供具科學實證的治療方案。",
  img: "https://wanted-kite.10web.cloud/wp-content/uploads/2026/03/Image-16-scaled.png?v=8rzv3uymueo"
}, {
  name: "\n",
  role: "註冊護士",
  bio: "具備豐富的急症室與居家護理實戰經驗。精於傷口護理及慢性病管理，以專業與細心守護長者的健康。",
  img: "https://wanted-kite.10web.cloud/wp-content/uploads/2026/03/9-scaled.png?v=7spsfpaymxw"
}];
export default function CrossProfessionalMedicalTeam() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="74322" id="專業醫護團隊" className="bg-secondary/30 py-20 lg:py-28 overflow-hidden">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {}
        <div className="mx-auto max-w-2xl text-center mb-16">
          <h2 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl mb-4">
            專業醫護團隊
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            我們由資深護理團隊領導，結合多學科治療師與專業護理人員，將最有溫度的專業照護直接帶到您的家中。
          </p>
        </div>

        {}
        <div ref={ref} className={`grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {teamMembers.map((member, i) => <div data-index={i} key={i} className="group relative flex flex-col overflow-hidden rounded-3xl border-8 border-white bg-card shadow-xl shadow-primary/5 transition-all duration-300 hover:shadow-2xl hover:-translate-y-1">
              {}
              <div className="relative aspect-[3/4] w-full overflow-hidden bg-muted">
                <img src={member.img} alt={`${member.name} - ${member.role}`} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" />
                
                {}
                <div className="absolute inset-0 flex flex-col items-center justify-center bg-primary/85 p-6 text-center opacity-0 transition-opacity duration-300 group-hover:opacity-100 backdrop-blur-md">
                  <p className="text-sm leading-relaxed text-primary-foreground font-medium translate-y-4 transition-transform duration-300 group-hover:translate-y-0">
                    {member.bio}
                  </p>
                </div>
              </div>

              {}
              <div className="flex flex-col items-center p-5 text-center z-10 bg-card">
                <h3 className="text-xl font-bold text-foreground">{member.name}</h3>
                <p className="mt-1 text-sm font-bold tracking-widest text-primary uppercase">{member.role}</p>
              </div>
            </div>)}
        </div>

        {}
        <div className="mt-20 flex flex-col items-center justify-center text-center">
          <p className="text-muted-foreground mb-6 max-w-md">
            我們深信每一位服務使用者都值得擁有尊嚴的生活。如果您也抱持「芯」繫健康的理想，歡迎加入我們。
          </p>
          
          {}
          <div className="relative inline-flex group">
            <div className="absolute inset-0 rounded-full bg-primary/30 animate-ping opacity-75 group-hover:opacity-100 transition-opacity duration-300"></div>
            <Button asChild size="lg" className="relative rounded-full px-8 py-6 text-lg shadow-xl shadow-primary/20 transition-transform hover:scale-105 bg-primary hover:bg-primary/90">
              <Link to="/ContactUsPage">
                <HeartHandshake className="mr-2 h-5 w-5" />
                加入我們的團隊
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}